import moment from 'moment';
import DurationBetweenTwoDatesField from './DurationBetweenTwoDatesField';
import { FieldProps } from '../types';

const DateTimerField = ({ value, source, label, shortValue }: FieldProps & { shortValue?: boolean }) => {
  return (
    <DurationBetweenTwoDatesField
      dateFromValue={moment()}
      dateToValue={value}
      dateToSource={source}
      label={label}
      shortValue={shortValue}
    />
  );
};

export default DateTimerField;
